<button class="burger-menu"
        [class.active]="active"
        (click)="change()">
  <span class="burger-menu__item"></span>
  <span class="burger-menu__item"></span>
  <span class="burger-menu__item"></span>
</button>
